
interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white/95'}`}>
      <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img 
            src="https://public.readdy.ai/ai/img_res/84ec51ae-dec0-4329-abc8-1987c5214616.png" 
            alt="Business Contracting Hub" 
            className="h-12 w-auto object-contain"
          />
        </div>
        
        <div className="flex items-center gap-10">
          <button onClick={() => scrollToSection('services')} className="text-[15px] font-medium text-gray-700 hover:text-[#1A2B3C] transition-colors cursor-pointer whitespace-nowrap">
            Services
          </button>
          <button onClick={() => scrollToSection('about')} className="text-[15px] font-medium text-gray-700 hover:text-[#1A2B3C] transition-colors cursor-pointer whitespace-nowrap">
            About
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="text-[15px] font-medium text-gray-700 hover:text-[#1A2B3C] transition-colors cursor-pointer whitespace-nowrap">
            Testimonials
          </button>
          <button onClick={() => scrollToSection('contact')} className="text-[15px] font-medium text-gray-700 hover:text-[#1A2B3C] transition-colors cursor-pointer whitespace-nowrap">
            Contact
          </button>
        </div>
        
        <button onClick={() => scrollToSection('contact')} className="bg-[#1A2B3C] text-white px-6 py-2.5 rounded-full text-[14px] font-medium hover:bg-[#D4AF37] transition-all duration-300 whitespace-nowrap cursor-pointer">
          Get Started →
        </button>
      </div>
    </nav>
  );
}
